import { render, staticRenderFns } from "./GroupTypeBenefitCreate.vue?vue&type=template&id=4529013e&"
import script from "./GroupTypeBenefitCreate.vue?vue&type=script&lang=js&"
export * from "./GroupTypeBenefitCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports